<ngx-simplebar class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
    [options]="{ forceVisible: true }">
    <form [formGroup]="propertyAddressForm" *ngIf="isView$.getValue()" #formElementRef>
        <div class="row">
            <div class="card">
                <div class="card-header border-0 align-items-center d-flex py-0">
                    <h4 class="card-title mb-0 flex-grow-1"></h4>
                    <div class="dropdown">
                        <button
                            class="btn btn-outline-primary waves-effect waves-primary btn-sm dropdown border-input-custom"
                            type="button" data-bs-toggle="dropdown" aria-expanded="false"
                            data-bs-auto-close="outside"><i class=" ri-settings-2-line fs-14"></i>
                        </button>
                        <div class="border border-primary dropdown-menu dropdown-menu-end p-3 border-input-custom"
                            style="min-width: 12rem;">
                            <div class="d-flex flex-column gap-2 filter-check">
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="hide-address"
                                        formControlName="hidePropertyAddress">
                                    <label class="form-check-label" for="hide-address">
                                        {{ 't-m-properties.t-hide-address' | translate }}
                                    </label>
                                </div>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="hide-georeference"
                                        formControlName="hideMap">
                                    <label class="form-check-label" for="hide-georeference">
                                        {{ 't-m-properties.t-hide-georeference' | translate }}
                                    </label>
                                </div>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="hide-district"
                                        formControlName="hideDistrict">
                                    <label class="form-check-label" for="hide-district">
                                        {{ 't-m-properties.t-hide-district' | translate }}
                                    </label>
                                </div>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="hide-county"
                                        formControlName="hideCounty">
                                    <label class="form-check-label" for="hide-county">
                                        {{ 't-m-properties.t-hide-county' | translate }}
                                    </label>
                                </div>
                                <div class="form-check form-switch">
                                    <input class="form-check-input" type="checkbox" role="switch" id="hide-parish"
                                        formControlName="hideParish">
                                    <label class="form-check-label" for="hide-parish">
                                        {{ 't-m-properties.t-hide-parish' | translate }}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-4">
                            <div class="mb-3">
                                <label for="countryInput" class="form-label">
                                    {{ 't-m-properties.t-country' | translate }}

                                </label>
                                <ng-select [items]="countries" [multiple]="false"
                                    placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-country' | translate }}"
                                    bindLabel="name" bindValue="id" required formControlName="country"
                                    [ngClass]="{ 'is-invalid': submitted && form['country'].errors  && form['country'].errors['required']  }"
                                    (change)="changeCountry($event)" [clearable]="false"
                                    [ngClass]="{ 'is-warning': submitted && form['country'].errors && form['country'].errors['warning'] }">
                                </ng-select>
                                <div *ngIf="submitted && form['country'].errors" class="invalid-feedback" align="left">
                                    <div *ngIf="form['country'].errors['required']">
                                        {{ 't-m-properties.t-country' | translate }}
                                        {{ 't-general.t-is-required'|translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--end col-->

                        <div class="col-lg-4">
                            <div class="mb-3">
                                <label for="regionInput" class="form-label">
                                    {{ 't-m-properties.t-region' | translate }}
                                </label>
                                <ng-select [items]="regions" [multiple]="false"
                                    placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-region' | translate }}"
                                    bindLabel="name" bindValue="id" required formControlName="region"
                                    [ngClass]="{ 'is-invalid': submitted && form['region'].errors  && form['region'].errors['required'] }"
                                    (change)="changeRegion($event)" [clearable]="false"
                                    [ngClass]="{ 'is-warning': submitted && form['region'].errors && form['region'].errors['warning'] }">
                                </ng-select>
                                <div *ngIf="submitted && form['region'].errors" class="invalid-feedback" align="left">
                                    <div *ngIf="form['region'].errors['required']">
                                        {{ 't-m-properties.t-region' | translate }}
                                        {{ 't-general.t-is-required'|translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--end col-->
                        <div class="col-lg-4">
                            <div class="mb-3">
                                <label for="districtInput" class="form-label">
                                    {{ 't-m-properties.t-district' | translate }}
                                </label>
                                <ng-select [items]="districts" [multiple]="false"
                                    placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-district' | translate }}"
                                    bindLabel="name" bindValue="id" required formControlName="district"
                                    [ngClass]="{ 'is-invalid': submitted && form['district'].errors  && form['district'].errors['required'] }"
                                    (change)="changeDistrict($event)" [clearable]="false"
                                    [ngClass]="{ 'is-warning': submitted && form['district'].errors && form['district'].errors['warning'] }">
                                </ng-select>
                                <div *ngIf="submitted && form['district'].errors" class="invalid-feedback" align="left">
                                    <div *ngIf="form['district'].errors['required']">
                                        {{ 't-m-properties.t-district' | translate }}
                                        {{ 't-general.t-is-required'|translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--end col-->
                        <div class="col-lg-4">
                            <div class="mb-3">
                                <label for="countyInput" class="form-label">
                                    {{ 't-m-properties.t-county' | translate }}
                                </label>
                                <ng-select [items]="counties" [multiple]="false"
                                    placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-county' | translate }}"
                                    bindLabel="name" bindValue="id" required formControlName="county"
                                    [ngClass]="{ 'is-invalid': submitted && form['county'].errors && form['county'].errors['required'] }"
                                    (change)="changeCounty($event)" [clearable]="false"
                                    [ngClass]="{ 'is-warning': submitted && form['county'].errors && form['county'].errors['warning'] }">
                                </ng-select>
                                <div *ngIf="submitted && form['county'].errors" class="invalid-feedback" align="left">
                                    <div *ngIf="form['county'].errors['required']">
                                        {{ 't-m-properties.t-county' | translate }}
                                        {{ 't-general.t-is-required'|translate }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!--end col-->
                        <div class="col-lg-4">
                            <div class="mb-3">
                                <label for="parishInput" class="form-label">
                                    {{ 't-m-properties.t-parish' | translate }}
                                </label>
                                <ng-select class="parish-select" [items]="parishes" [multiple]="false"
                                    placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-parish' | translate }}"
                                    bindLabel="name" bindValue="id" required formControlName="parish"
                                    [ngClass]="{ 'is-invalid': submitted && form['parish'].errors && form['parish'].errors['required']  }"
                                    [clearable]="false"
                                    [ngClass]="{ 'is-warning': submitted && form['parish'].errors && form['parish'].errors['warning'] }">
                                </ng-select>
                                <div *ngIf="submitted && form['parish'].errors" class="invalid-feedback" align="left">
                                    <div *ngIf="form['parish'].errors['required']">
                                        {{ 't-m-properties.t-parish' | translate }}
                                        {{ 't-general.t-is-required'|translate }}
                                    </div>
                                </div>
                                <div *ngIf="showOutdatedParishNotice" class="form-text text-muted" align="left">
                                    <i class="ri-error-warning-line align-bottom"></i>
                                    {{ 't-m-properties.t-outdated-parish' | translate }}
                                </div>
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
            </div>
        </div>
        <!--end row-->
        <div class="row">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <!--end col-->
                        <div class="col-lg-6">
                            <div class="mb-3">
                                <label for="addressInput" class="form-label">
                                    {{ 't-m-properties.t-address' | translate }}
                                </label>
                                <input type="text" class="form-control" id="addressInput"
                                    placeholder="  {{ 't-enter' | translate }}   {{ 't-m-properties.t-address' | translate }}"
                                    formControlName="address" />
                            </div>
                        </div>
                        <!--end col-->
                        <div class="col-lg-3">
                            <div class="mb-3">
                                <label for="zipcodeInput" class="form-label">
                                    {{ 't-m-properties.t-zip-code' | translate }}
                                </label>
                                <input type="text" class="form-control" id="zipcodeInput"
                                    [placeholder]="postalCodeFormat" [mask]="postalCodeFormat"
                                    formControlName="zipCode" />
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                    <div class="row">
                        <div class="col-lg-3">
                            <div class="mb-3">
                                <label for="doorInput" class="form-label">
                                    {{ 't-m-properties.t-door' | translate }}
                                </label>
                                <input type="text" class="form-control" id="doorInput"
                                    placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-door' | translate }}"
                                    formControlName="doorNumber" />
                            </div>
                        </div>
                        <!--end col-->
                        <div class="col-lg-3">
                            <div class="mb-3">
                                <label for="fractionInput" class="form-label">
                                    {{ 't-m-properties.t-fraction' | translate }}
                                </label>
                                <input type="text" class="form-control" id="fractionInput"
                                    placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-fraction' | translate }}"
                                    formControlName="fraction" />
                            </div>
                        </div>
                        <!--end col-->
                        <div class="col-lg-3">
                            <div class="mb-3">
                                <label for="floorInput" class="form-label">
                                    {{ 't-m-properties.t-floor' | translate }}
                                </label>
                                <input type="text" class="form-control" id="floorInput"
                                    placeholder=" {{ 't-enter' | translate }}  {{ 't-m-properties.t-floor' | translate }}"
                                    formControlName="floor">
                            </div>
                        </div>
                        <!--end col-->
                    </div>
                    <!--end row-->
                </div>
            </div>
            <!-- end card -->
        </div>
        <!--end row-->
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="align-items-center card-header d-flex pb-2">
                        <h4 class="card-title mb-0">
                            {{ 't-m-properties.t-geo-reference' | translate }}
                        </h4>
                        <div class="ms-2">
                            <button
                                *ngIf="!validateLocationBtn()"
                                ngbTooltip="{{form['country'].value && form['country'].value !== portugalCountry?.id ? ('t-georeference-tooltip-nozip' | translate) : ('t-georeference-tooltip' | translate)}}" class="btn p-0"><i
                                    class="fs-18 mdi mdi-refresh"></i></button>
                            <button
                                *ngIf="validateLocationBtn()"
                                (click)="refreshGeoreference()" class="btn p-0"><i
                                    class="fs-18 mdi mdi-refresh"></i></button>
                        </div>
                    </div><!-- end card header -->

                    <div class="card-body">
                        <!-- <div style="height: 300px;" leaflet [leafletOptions]="options"  (leafletMapReady)="onMapReady($event)">
                        <div [leafletLayers]="markersLayers"></div>
                    </div> -->
                        <div class="map-container" leaflet [leafletOptions]="options"
                            (leafletMapReady)="onMapReady($event)"
                            (leafletDoubleClick)="mapDblClick($event)" style="height: 300px;">
                        </div>
                    </div>
                    <!-- end card-body -->
                </div><!-- end card -->
            </div>
            <!-- end col -->
        </div>
    </form>
</ngx-simplebar>